const CAP = 99999999.99

export const roundRevenuePence = amount => {
  const negative = amount < 0
  const rounded = Math.floor(Math.abs(amount) * 100 + 1e-8 + 0.5) / 100
  return negative ? -rounded : rounded
}

/** Live preview of one day line. Blank is empty. Invalid text is an error. */
export const previewRevenueLine = ({ entry, multiplier }) => {
  if (entry == null || String(entry).trim() === '') {
    return { blank: true, calculated: null }
  }
  const parsed = Number(String(entry).trim())
  const factor = Number(multiplier)
  if (!Number.isFinite(parsed) || !Number.isFinite(factor)) {
    return { blank: false, error: 'Enter a number.', calculated: null }
  }
  if (Math.abs(parsed) > CAP) {
    return {
      blank: false,
      error: 'That amount is too large.',
      calculated: null,
    }
  }
  const calculated = roundRevenuePence(parsed * factor)
  if (Math.abs(calculated) > CAP) {
    return {
      blank: false,
      error: 'That amount is too large.',
      calculated: null,
    }
  }
  return { blank: false, calculated }
}

/** List label: Amount when the multiplier is exactly 1, otherwise × 3.50. */
export const describeRevenueCategoryMultiplier = multiplier => {
  const value = Number(multiplier)
  if (!Number.isFinite(value)) return '—'
  if (value === 1) return 'Amount'
  return `× ${value.toFixed(2)}`
}

export const previewRevenueTotal = lines => {
  const values = lines
    .map(line => line.calculated)
    .filter(value => value != null)
  if (!values.length) return null
  return roundRevenuePence(values.reduce((sum, value) => sum + value, 0))
}

export const formatRevenuePounds = amount => {
  if (amount == null || Number.isNaN(amount)) return '—'
  const negative = amount < 0
  const pounds = Math.abs(amount).toFixed(2)
  return `${negative ? '-' : ''}£${pounds}`
}
